"use client";

import { createContext, useContext, useState } from "react";

const MiniCartContext = createContext();

export function MiniCartProvider({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <MiniCartContext.Provider value={{ open, setOpen }}>
      {children}
    </MiniCartContext.Provider>
  );
}

export function useMiniCart() {
  return useContext(MiniCartContext);
}
